export class MessageData {
  public caption: string;
  public text: string;
  public data: any;
  public type: string;
  public confirm: () => void;
  public reject: () => void;
  public close: () => void;
}
